var _style, _radialGradient, _radialGradient2, _g, _g2, _path, _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLamp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "lamp",
    viewBox: "0 0 1280 2100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n    #lamp {\r\n      transform-origin: 50% 0%;\r\n      animation: pendulum alternate infinite 2s ease-in-out;\r\n    }\r\n    @keyframes pendulum {\r\n      from {transform: rotate(-1deg)}\r\n      to {transform: rotate(1deg)}\r\n\t  }\r\n    .off {\r\n      fill: none;\r\n      stroke: #ccc;\r\n      animation: none !important;\r\n    }\r\n  ")), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "halo-gradient",
    cx: 640,
    cy: 1566,
    r: 490,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.698,
    stopColor: "#ffc32d",
    stopOpacity: 0.419
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762,
    stopColor: "#ffca47",
    stopOpacity: 0.33
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822,
    stopColor: "#ffd367",
    stopOpacity: 0.247
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878,
    stopColor: "#ffde8d",
    stopOpacity: 0.169
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931,
    stopColor: "#ffebb9",
    stopOpacity: 0.111
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.981,
    stopColor: "#fff9e9",
    stopOpacity: 0.055
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "blob-gradient",
    cx: 640,
    cy: 1500,
    r: 390,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#ffb600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848,
    stopColor: "#f7ec13"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "light"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "halo",
    fill: "url(#halo-gradient)",
    strokeWidth: 0,
    cx: 640,
    cy: 1566,
    rx: 530,
    ry: 490
  }), /*#__PURE__*/React.createElement("path", {
    id: "blob",
    fill: "url(#blob-gradient)",
    stroke: "#fcee21",
    strokeWidth: 15,
    d: "M246.3,1490.8c0,217.5,176.3,393.8,393.8,393.8c229.5,0,391-200.8,393.7-393.8c1.7-119.2-40.5-218.7-130.7-292.2l0,0c-0.3-0.2-31.6-27.4-39-32.5c-97-76.6,13.9-155.6-100.4-157.6c-123-2.2-124.9,1.9-243.3,0c-113.9-1.9-1.4,78.1-103.4,157.9c-4.5,3.1-9,6.3-13.3,9.6C308.1,1247.8,246.3,1362.1,246.3,1490.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "string",
    fill: "none",
    stroke: "#e65400",
    strokeWidth: 20,
    d: "M687.1,1046.6v443.6c0,23.5,15.7,42.5,35,42.5h10c19.3,0,35-19,35-42.5l0,0c0-23.5-15.7-42.5-35-42.5h-184c-19.3,0-35,19-35,42.5l0,0c0,23.5,15.7,42.5,35,42.5h9c19.3,0,35-19,35-42.5v-443.6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#ccc",
    strokeWidth: 75,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 827.6,
    y1: 1009.1,
    x2: 452.6,
    y2: 1009.1
  }), /*#__PURE__*/React.createElement("line", {
    stroke: "#aaa",
    x1: 827.6,
    y1: 934.6,
    x2: 452.6,
    y2: 934.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 827.6,
    y1: 860.1,
    x2: 452.6,
    y2: 860.1
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#aaa",
    d: "M550.2,716.9h179.6c20.5,0,37.2,16.6,37.2,37.2v68.4H513v-68.4C513.1,733.6,529.7,716.9,550.2,716.9z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    stroke: "#666",
    strokeWidth: 20,
    x1: 640,
    y1: 716.9,
    x2: 640,
    y2: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLamp);
export default __webpack_public_path__ + "static/media/lamp.37c6eaace9930996647a4d981e930edb.svg";
export { ForwardRef as ReactComponent };